import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SaveChangesModalService {
  private readonly _modalOpenSubject = new Subject<boolean>();
  private readonly _decisionSubject = new Subject<boolean>();

  // Observable for modal visibility
  public get isModalOpen(): Observable<boolean> {
    return this._modalOpenSubject.asObservable();
  }

  // Open the modal
  public openModal() {
    this._modalOpenSubject.next(true);
  }

  // Close the modal
  public closeModal() {
    this._modalOpenSubject.next(false);
  }

  // Convert promise to observable for guard usage
  public showSaveChangesModal(): Observable<boolean> {
    this.openModal(); // Open the modal
    return this._decisionSubject.asObservable(); // Return as observable
  }

  // Respond to the user's decision from the modal
  public respond(decision: boolean) {
    this._decisionSubject.next(decision); // Emit decision
    this.closeModal(); // Close the modal after decision
  }
}
